import Cookies from 'js-cookie';
import { useCallback, useMemo } from 'react';
import useLocalStorageState from 'use-local-storage-state';

function useSessionId() {
    const [localStorageSessionId, setLocalStorageSessionId] = useLocalStorageState("sessionId", null);

    const get = useCallback(() => {
        // Get from cookies first
        const cookieSessionId = Cookies.get('session-id');
        if (cookieSessionId) {
            // console.log("Got session ID from cookies:", cookieSessionId);
            return cookieSessionId;
        }

        // Get from local storage second
        return localStorageSessionId;
    }, [localStorageSessionId]);

    const set = useCallback((sessionId) => {
        // Set to cookies if present there
        if (Cookies.get('session-id')) {
            if (sessionId) {
                // console.log("Setting session ID in cookies");
                Cookies.set('session-id', sessionId, { expires: 7 });
            } else {
                // console.log("Removing session ID from cookies");
                Cookies.remove('session-id');
            }
        }

        // Set to local storage
        setLocalStorageSessionId(sessionId);
    }, [setLocalStorageSessionId]);

    return useMemo(() => [get(), set], [get, set]);
}

export default useSessionId;
